const video = document.querySelector('video')
if(sessionStorage.getItem('buzz-clicked') == 'y' && sessionStorage.getItem('buzz-ever-clicked') != 'y'){
  loadingAnimation('https://cdn.shopify.com/videos/c/o/v/a6abffa74063424cb003eaa9aa013e68.webm', 'https://cdn.shopify.com/videos/c/o/v/085dff79c887466aab2560e150f189e5.webm')
}
else if(sessionStorage.getItem('philon-clicked') == 'y' && sessionStorage.getItem('philon-ever-clicked') != 'y'){
  loadingAnimation('https://cdn.shopify.com/videos/c/o/v/c4a91eb93e904ec8bc36d718584df02d.webm', 'https://cdn.shopify.com/videos/c/o/v/d41d25ad35c847fabfad05b2fa38dba4.webm')
}
else{
  video.style.display = 'none'
}

if(sessionStorage.getItem('buzz-clicked') == 'y') sessionStorage.setItem('buzz-ever-clicked', 'y')
if(sessionStorage.getItem('philon-clicked') == 'y') sessionStorage.setItem('philon-ever-clicked', 'y')

addEventListener('load', () => {
  const buzzLogo = document.querySelector('#logo-buzz')
  const philonLogo = document.querySelector('#logo-philon')
  
  buzzLogo.addEventListener('click', () => {
    sessionStorage.setItem('buzz-clicked', 'y')
  })
  philonLogo.addEventListener('click', () => {
    sessionStorage.setItem('philon-clicked', 'y')
  })
})

function loadingAnimation(desktopSrc, mobileSrc){
  setTimeout(() => {
    video.style.backgroundColor = 'transparent'
  }, 2000)

  setTimeout(() => {
    video.style.display = 'none'
  }, 8000)

  const source = document.createElement('source')
  if(innerWidth > 990){
    video.height = innerHeight
    setSource(source, desktopSrc)
  }
  else{
    video.width = innerWidth
    setSource(source, mobileSrc)
  }
  source.setAttribute('type', 'video/webm')
  video.appendChild(source)
}

function setSource(el, src){
  el.setAttribute('src', src)
}